import type { FunctionalComponent } from "preact";
import { useEffect } from "preact/hooks";
import { useMap } from "react-leaflet";
import L from "leaflet";
import type MvArea from "models/MvArea";
export interface CenterMapProps {
    areas: MvArea[];
}

const CenterMap: FunctionalComponent<CenterMapProps> = ({
    areas,
}: CenterMapProps) => {
    const map = useMap();
    const mapWidth = map.getSize().x;

    const centerMap = (mapInstance: L.Map, areas: MvArea[]) => {
        const visibleCircles: L.LatLngBounds[] = [];
        const filteredAreas = areas.filter((area) => area.result !== null);
        if (filteredAreas.length > 0) {
            filteredAreas.forEach((a) => {
                const bounds = L.latLng(
                    a.result?.breedtegraad ?? 0,
                    a.result?.lengtegraad || 0,
                ).toBounds(a.inputParams.radius ?? 300);
                visibleCircles.push(bounds);
            });

            // Fit the map with the visible markers bounds
            const bounds = L.latLngBounds([]);
            visibleCircles.forEach((circle) => bounds.extend(circle));
            mapInstance.flyToBounds(bounds, {
                padding: [84, 84],
                animate: true,
                duration: 0.5,
            });
        }
    };

    useEffect(() => {
        if (mapWidth != 0) {
            centerMap(map, areas);
        }
    }, [areas, mapWidth]);

    useEffect(() => {
        const timer = setInterval(() => {
            if (map.getSize().x === 0) map.invalidateSize();
        }, 500);
        return () => clearInterval(timer);
    }, [map]);

    return null;
};

export default CenterMap;
